import React, { useState } from 'react';
import { startSsoStepUp, SsoStepUpPurpose } from '../../services/ssoApi';

/**
 * "Confirm with Microsoft": the step-up for a Microsoft-signed-in administrator
 * who is refused with STEP_UP_SSO_REQUIRED. It sends the browser to Microsoft
 * and back to this page (the server remembers where from `returnTo`); the act
 * is then done again, not resumed.
 */
export default function ConfirmWithMicrosoft({ purpose, className, label = 'Confirm with Microsoft' }: {
  purpose: SsoStepUpPurpose;
  className?: string;
  label?: string;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      className={className}
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        // On success the browser is leaving; on refusal the helper has shown why.
        const leaving = await startSsoStepUp(purpose);
        if (!leaving) setBusy(false);
      }}
    >
      {busy ? 'Opening Microsoft…' : label}
    </button>
  );
}
